import { render, staticRenderFns } from "./LifestyleVoip.vue?vue&type=template&id=4d16af1a&scoped=true"
import script from "./LifestyleVoip.vue?vue&type=script&lang=js"
export * from "./LifestyleVoip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16af1a",
  null
  
)

export default component.exports